export const LORA = 'lora';
export const MQTT = 'mqtt';
export const CUSTOM = 'custom';

// `connect` is shown in the rail but happens on the device page after submit.
export const stepsFor = (protocol) => (
  protocol === MQTT ? ['protocol', 'details', 'connect'] : ['protocol', 'device', 'details', 'connect']
);

// Same cleanup the old modal applied to every serial: uppercase, letters and digits only.
export const normalizeDevEui = (raw) => String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

export const validateDetails = (state) => {
  const errors = {};
  const serial = state.serial || '';
  if ((state.name || '').length < 3) errors.name = 'Name must be at least 3 characters';
  if (state.protocol === LORA) {
    if (serial.length !== 16) errors.serial = 'DevEUI must be 16 characters';
    if (!state.sourceId) errors.source = 'Select a source';
    if (state.model === CUSTOM && !state.profileId) errors.profile = 'Select a profile';
  } else if (serial.length < 6 || serial.length > 16) {
    errors.serial = 'Serial must be 6 to 16 characters';
  }
  return errors;
};

export const isValid = (state) => Object.keys(validateDetails(state)).length === 0;

export const buildPayload = (state) => {
  if (state.protocol === MQTT) return { name: state.name, type: MQTT, serial: state.serial };
  const base = { name: state.name, type: LORA, serial: state.serial, source: state.sourceId };
  return state.model === CUSTOM
    ? { ...base, profile: state.profileId }
    : { ...base, catalogModel: state.model };
};
